var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68164 25.3437C9.06064 25.3437 8.55664 24.8397 8.55664 24.2187V13.9287C8.55664 13.3077 9.06064 12.8037 9.68164 12.8037C10.3026 12.8037 10.8066 13.3077 10.8066 13.9287V24.2187C10.8066 24.8397 10.3026 25.3437 9.68164 25.3437Z",
    fill: "#B9A978"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6821 25.3424C16.0611 25.3424 15.5571 24.8384 15.5571 24.2174V9.00293C15.5571 8.38193 16.0611 7.87793 16.6821 7.87793C17.3031 7.87793 17.8071 8.38193 17.8071 9.00293V24.2174C17.8071 24.8384 17.3031 25.3424 16.6821 25.3424Z",
    fill: "#B9A978"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5676 25.3422C22.9466 25.3422 22.4426 24.8382 22.4426 24.2172V19.3662C22.4426 18.7452 22.9466 18.2412 23.5676 18.2412C24.1886 18.2412 24.6926 18.7452 24.6926 19.3662V24.2172C24.6926 24.8382 24.1886 25.3422 23.5676 25.3422Z",
    fill: "#B9A978"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.596 2.75C5.438 2.75 2.75 5.5955 2.75 10.0025V23.2475C2.75 27.6545 5.438 30.5 9.596 30.5H23.654C27.8135 30.5 30.5 27.6545 30.5 23.2475V10.0025C30.5 5.5955 27.8135 2.75 23.654 2.75H9.596ZM23.654 32.75H9.596C4.1555 32.75 0.5 28.931 0.5 23.2475V10.0025C0.5 4.319 4.1555 0.5 9.596 0.5H23.654C29.0945 0.5 32.75 4.319 32.75 10.0025V23.2475C32.75 28.931 29.0945 32.75 23.654 32.75Z",
    fill: "#B9A978"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionChart);
export default __webpack_public_path__ + "static/media/Subscription-chart.4849fa8bc05b96b1f91db8ee939f8ebc.svg";
export { ForwardRef as ReactComponent };